<template>
  <div class="station">
    
    <van-divider
      :style="{ color: '#1989fa', borderColor: '#1989fa', margin:0,height:'50px',fontSize:'16px',}"
    >
    服 务 站 管 理
    </van-divider>
    <van-row>
        <div class="imgBox sjgl" @click="goPlate">
          <van-row>
          <van-col :span="12">
            <img src="@/assets/data.png" style="border-radius: 50%;vertical-align: middle;">
          </van-col>
          <van-col :span="8">
            <span>取牌确认</span>
          </van-col>
        </van-row>   
        </div>
    </van-row>
    <van-row>
          <div class="imgBox sjcx" @click="goHistory">
            <van-row >
            <van-col :span="12">
              <img src="@/assets/query.png" style="border-radius: 50%;vertical-align: middle;">
            </van-col>
            <van-col :span="8">
              <span>历史记录</span>
            </van-col>
          </van-row>   
          </div>
      </van-row>
    
    <div style="margin: 16px;">
          <van-button round block plain hairline type="info" style="margin-top: 2%;" @click="exit">退出登录</van-button>
    </div>
    <!-- <van-row>
        <van-tabs v-model="active">
          <div class="content">
            <van-tab v-for="item in titleList" :key="item.index" :title="item.title">
              <getPlate class="getPlate" v-if="item.index == '1'" />
              <history class="history" v-if="item.index == '2'" />
            </van-tab>
          </div>
        </van-tabs>
    </van-row> -->
  </div>
</template>

<script>
import getPlate from '../../components/station/getPlate.vue';
import history from '../../components/station/history.vue';
export default {
  components:{
    getPlate,
    history
  },
  data(){
    return{
      active:0,// 0申请信息查询，1身份证查询
      titleList:[
          {'index':'1','title':'取牌确认'},
          {'index':'2','title':'历史记录'},
          // {'index':'3','title':'逾期未取'},
          // {'index':'4','title':'存储位置'},
          // {'index':'5','title':'历史记录'},
      ]
    }
  },
  methods:{
    // 退出
    exit(){
        localStorage.removeItem('Authorization')
        this.$router.push('/managerLogin')
      },
    // 取牌确认
    goPlate(){
      console.log('取牌确认');
      this.$router.push('/getPlate')
    },
    // 历史记录
    goHistory(){
      console.log('历史记录');
      this.$router.push('/queryHistory')
    },
  }
}
</script>

<style lang="scss">
.station{
  .van-tab--active{
      color: #0283ef;
    }
    .van-tabs__line{
      background-color: #0283ef;
    }
  .content{
    overflow-y: auto;//内容溢出垂直滚动
    height: calc(100vh - 110px);//内容区高度，确保占满剩余可视窗口
  }
  .imgBox{
    margin: 2%;
    width: 95%;
    height: 110px;
    border-radius: 10px;
    line-height: 110px;
    color: white;
    font-size: 28px;
    background-size: cover; /* 背景图片覆盖整个容器 */
    background-repeat: no-repeat; /* 背景图片不重复 */
    background-clip: content-box; /* 背景裁剪到内容区域 */
    img{
      width: 85px;
      height: 85px;
    }
  }
  .sjcx{
    background-image: url('../../assets/sjcxbgc.jpg');
  }
  .sjgl{
    background-image: url('../../assets/sjglbgc.jpg');
  }
}
 
</style>